const styles = (theme) => ({
  dialogTitle: {
    padding: "14px 24px 0 24",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dialog: {
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    minWidth: "80%",
    height: "90%",
    fontWeight: "600",
    maxHeight: "750px",
  },
  dialogWrapper: {},
  dialogContent: {
    overflowX: "hidden",
    padding: "10px 24px",
  },
  dialogFooter: {
    padding: "10px 15px",
  },
  closeButton: {
    color: theme.iconColor,
    padding: 0,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    top: "19px",
  },
  dialogTitlestyle: {
    padding: 0,
    marginBottom: "25px",
  },
  actionButton: {
    margin: "0 -4 0 16", 
    minWidth: "136px",
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
  },
  disabledButton: {},
  grayBar: {
    height: 1,
    backgroundColor: theme.AppBGColor,
    marginTop: 14,
    marginBottom: 14,
  },
  gridContainer:{
    height:"89%"
  }
});

export default styles